import React from 'react';

/**
 * Red de seguridad global: si cualquier componente lanza durante el render,
 * React desmontaría todo el árbol y dejaría la pantalla en blanco. Este boundary
 * captura ese error y muestra una pantalla de fallback usable en su lugar.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary capturó un error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.assign('/');
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen gradient-mesh flex items-center justify-center px-4">
          <div className="w-full max-w-md bg-card rounded-3xl p-8 shadow-card border border-border text-center">
            <h1 className="text-2xl font-fraunces font-semibold text-foreground mb-3">
              Ups, algo salió mal
            </h1>
            <p className="text-muted-foreground mb-6">
              Ocurrió un error inesperado. Probá volver al inicio e intentar de nuevo.
            </p>
            <button
              onClick={this.handleReload}
              className="rounded-full px-6 py-3 bg-primary text-primary-foreground hover:bg-primary/90 text-base font-medium transition-colors"
            >
              Volver al inicio
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
